(function ($) {

	// Single product modal swiper
	var single_product_lightbox_swiper,
		single_product_lightbox_swiper_thumbs,
		open_attribute = "data-open-lightbox-gallery",
		close_attribute = "data-close-lightbox-gallery",
		show_more_attribute = "data-show-more-gallery"

	function init_gallery(){

		single_product_lightbox_swiper_thumbs = new Swiper(".product__thumbnail-lightbox-swiper", {
			spaceBetween: 10,
			slidesPerView: 'auto',
			freeMode: true,
			watchSlidesProgress: true,
			cssMode: true,
			observer: true,
			direction: 'vertical',
			threshold: 10,
			mousewheel: {
				forceToAxis: true,
			},
		});

		// Single product gallery Swiper
		single_product_lightbox_swiper = new Swiper('.product-detail-gallery-lightbox-swiper', {
			// initialSlide: initialSlide,
			speed: 300,
			lazy: {
				loadPrevNext: true,
				loadPrevNextAmount: 2
			},
			pagination: {
				el: '.swiper-lightbox-pagination',
				type: 'fraction',
			},
			navigation: {
				nextEl: ".swiper-lightbox-arrow-next",
				prevEl: ".swiper-lightbox-arrow-prev",
			},
			thumbs: {
				swiper: single_product_lightbox_swiper_thumbs,
			},
		});

	}

	// Init sidebar open
	$("[" + open_attribute + "]").click(function (e) {
		var init_slide = parseInt($(this).attr('lightbox-gallery-slide-to'))
		open_gallery(init_slide)
	})

	// Init show more
	$("[" + show_more_attribute + "]").click(function (e) {
		$('.product-detail-gallery__item').removeClass('product-detail-gallery__item-hidden');
		$(this).hide();
	})

	// Init sidebar close
	$("[" + close_attribute + "]").click(function (e) {
		close_gallery()
	})

	// Keyboard arrows sliding
	$("body").keydown(function (e) {
		if(single_product_lightbox_swiper){
			if (e.keyCode == 38 || e.keyCode == 39) {
				single_product_lightbox_swiper.slideNext();
			} else if (e.keyCode == 37 || e.keyCode == 40) {
				single_product_lightbox_swiper.slidePrev();
			}
		}
	});

	// init_gallery()

	function open_gallery(init_slide){
		setTimeout(() => {
			$('html').addClass('has-modal--lightbox-gallery');
			init_gallery()

			single_product_lightbox_swiper.slideTo(init_slide-1)
			single_product_lightbox_swiper.update()
			// single_product_lightbox_swiper_thumbs.init()
			// single_product_lightbox_swiper_thumbs.update(init_slide-1)
			single_product_lightbox_swiper_thumbs.setProgress(init_slide-1)

		}, 100)
	}

	function close_gallery(){
		$('html').removeClass('has-modal--lightbox-gallery');
	}

	$(document).keyup(function (e) {
		if (e.key === "Escape") { // escape key maps to keycode `27`
			close_gallery()
		}
	});


	// Single product mobile swiper
	var single_product_swiper;
	var prevWidth = 0; // 0 for first init

	function init_single_product_swiper() {

		var currentWidth = window.screen.width

		// Width change only
		if (currentWidth == prevWidth) {
			return
		}
		prevWidth = currentWidth

		if (single_product_swiper && $('.product-detail-gallery-swiper').length) {
			single_product_swiper.destroy()
		}

		// Single product gallery Swiper
		if (currentWidth < 900) {
			single_product_swiper = new Swiper('.product-detail-gallery-swiper', {
				speed: 300,
				slidesPerView: 1,
				navigation: {
					nextEl: ".product-detail-gallery-next",
					prevEl: ".product-detail-gallery-prev",
				},
				pagination: {
					el: ".swiper-pagination",
					type: "fraction",
				},
			});
		}
	}

	$(window).on('load resize', init_single_product_swiper);

})(jQuery);